import { type BreadcrumbItem, NavigationBreadcrumbs } from "~/features/breadcrumbs/components/NavigationBreadcrumbs";
import ShareButton from "~/features/shareButton/ShareButton";

import classes from "~/features/breadcrumbs/components/NavigationBreadcrumbs.module.less";

interface Props {
  items: BreadcrumbItem[];
}

export function createNavigationBreadcrumbs(data: Props) {
  return (
    <div className={"scha__screen-only js-header-negative-offset"}>
      <div className={classes.root}>
        <NavigationBreadcrumbs {...data} />
        <ShareButton />
      </div>
    </div>
  );
}
